import { cn } from "$/lib/utils/functions/misc.functions";
import Flexbox from "../../common/Flexbox";
import type { BaseInputProps } from "./BaseInput.types";
import { forwardRef } from "react";

const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>(
  (
    {
      className,
      autoComplete,
      isError,
      errorMessage,
      type = "text",
      Icon,
      EndIcon,
      ...props
    },
    ref,
  ) => {
    return (
      <Flexbox fullWidth justify="center" className="relative">
        {Icon && (
          <div className="absolute top-1/2 -translate-y-1/2 transform pl-2">
            <Icon />
          </div>
        )}

        <input
          type={type}
          aria-invalid={isError}
          aria-describedby={props["aria-describedby"] || errorMessage}
          autoComplete={
            autoComplete === undefined || autoComplete ? "on" : "off"
          }
          ref={ref}
          className={cn(
            "border-primary-light border-1 min-h-11 w-full rounded-lg border border-neutral-400 bg-white px-4 py-3 text-neutral-900 outline-0 duration-150 placeholder:text-neutral-400 focus:outline-0 disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-400 aria-invalid:border-error",
            {
              "focus:border-primary-500 focus:outline-primary-500": !isError,
            },
            {
              "focus:ring-error aria-invalid:focus:border-error": isError,
            },
            "border-0 bg-primary-100",
            { "pl-10": !!Icon },
            className,
          )}
          {...props}
        />

        {EndIcon && (
          <div className="absolute right-4 top-1/2 -translate-y-1/2 transform">
            <EndIcon />
          </div>
        )}
      </Flexbox>
    );
  },
);

BaseInput.displayName = "BaseInput";

export default BaseInput;
